// ConceptionCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { Conception_EndPoint } from "./ConstantsWomenCalculator";
import { ConceptionTable } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = 'Kalkulator Tanggal Pembuahan - Hitung Hari Pembuahan dengan Mudah dan Akurat';
const DESCRIPTION = 'Kalkulator tanggal pembuahan, masukkan tanggal haid terakhir untuk menghitung hari pembuahan secara akurat dan menentukan peluang kehamilan.';
const KEYWORDS = 'kalkulator tanggal pembuahan, waktu pembuahan, hitung hari pembuahan, prediksi tanggal pembuahan, kalkulator masa subur, hitung masa subur, tentukan tanggal pembuahan, kalkulator waktu pembuahan, analisis pembuahan, kalender pembuahan, kalkulator kehamilan'
const OG_URL = 'https://do-calculate.com/calculator/id/conception/';
const apiEndpoint = `${SERVER_URL}/${Conception_EndPoint}`;
function ConceptionCalculator() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculateConception = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data["result"]);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
       <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> {TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Dengan kalkulator waktu pembuahan sel telur, Anda dapat mengetahui hari-hari di mana tingkat kesuburan Anda meningkat, yaitu waktu ovulasi, sehingga dapat menyesuaikan hubungan intim dan meningkatkan peluang kehamilan. Kalkulator waktu pembuahan sel telur membantu menentukan hari-hari paling subur dalam bulan Anda, berdasarkan tanggal haid terakhir dan panjang siklus. Dengan cara ini, Anda dapat menentukan waktu terbaik untuk berhubungan dengan suami dan berusaha mencapai kehamilan. Untuk menggunakan kalkulator waktu pembuahan sel telur, ikuti langkah-langkah sederhana berikut:
                </p>
                <ul>
                  <li>
                    Masukkan tanggal hari pertama haid terakhir pada kolom yang tersedia dengan format hari/bulan/tahun, seperti contoh berikut: 01/04/2009.
                  </li>
                  <li>
                    Untuk memastikan akurasi, Anda dapat mengisi kolom "Haid sebelum terakhir" dan "Haid kedua sebelum terakhir" jika Anda mengetahuinya.
                  </li>
                  <li>
                    Tentukan pada kolom kedua durasi siklus haid Anda, dan jika Anda tidak yakin, kami sarankan memilih 28 hari.
                  </li>
                  <li>Tekan tombol "Hitung".</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Waktu Pembuahan
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>Hari pertama</strong> haid terakhir
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      Rata-rata waktu antar siklus
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">Hari</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateConception}
                         >
                    Hitung
                    </button>                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <ConceptionTable result={result}></ConceptionTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
                    <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Deskripsi Kalkulator Waktu Pembuahan : </div>
              <div className="info-section-body">
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>Masa Subur</b>{" "}
                  </u>{" "}
                </h2>
                <p>
                  Masa subur adalah periode yang berlangsung selama tiga hari di mana kemungkinan terjadinya kehamilan pada wanita adalah yang tertinggi. Pembuahan biasanya didefinisikan sebagai awal kehamilan, ketika sel telur dibuahi. Ini dapat terjadi baik melalui pembuahan di laboratorium maupun melalui hubungan intim. Dalam kasus hubungan intim, sperma tetap hidup di dalam tubuh wanita hingga 5 hari (bisa mencapai 7 hari dalam beberapa kasus). Jadi, ketika Anda mencoba hamil, hubungan intim secara teratur sebelum 5 hari ovulasi dan pada hari ovulasi itu sendiri dapat meningkatkan kemungkinan pembuahan yang berhasil. Ini dikenal sebagai masa subur. Selain itu, penelitian menunjukkan bahwa dalam masa subur ini, 3 hari terakhir adalah yang paling subur, dan hubungan intim selama periode ini akan mengakibatkan kehamilan pada sekitar 30% kasus.
                </p>
                <hr />
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>Cinta dan Reproduksi</b>{" "}
                  </u>{" "}
                </h2>
                <p>
                  Keinginan untuk memiliki anak berkaitan dengan cinta kepada pasangan dan anak yang akan Anda lihat tumbuh. Terlepas dari seberapa dalam keinginan ini pada kebanyakan pasangan, kehidupan sering kali menghalanginya. Kita merasa tegang dan cemas akibat pekerjaan dan menghabiskan sebagian besar waktu kita untuk menangani kesibukan sehari-hari dan pekerjaan rumah tangga. Akibatnya, kita tidak memiliki cukup waktu atau tidak memiliki keinginan untuk berhubungan intim sebanyak yang kita inginkan. Namun, hal pertama yang perlu diketahui ketika Anda mencoba hamil adalah bahwa hubungan intim secara teratur dengan pasangan adalah persiapan terbaik. Ketika Anda mencoba hamil, Anda harus berhubungan intim secara teratur - setidaknya dua hingga tiga kali seminggu - bahkan ketika Anda tidak merasa subur atau dekat dengan hari ovulasi. Hubungan intim secara teratur mempersiapkan tubuh wanita untuk reproduksi dan meningkatkan tingkat hormonal yang terkait dengannya. Penurunan kesuburan itu sendiri terkait dengan penurunan gairah seksual. Gaya hidup dan hubungan Anda meningkatkan peluang kehamilan. Hubungan intim secara teratur juga menciptakan kondisi yang lebih menguntungkan di vagina. Kehadiran lendir rahim berkualitas tinggi (atau seperti putih telur) meningkatkan kesuburan dengan menciptakan kondisi yang lebih menguntungkan di vagina yang membantu melindungi sperma dan memperpanjang masa hidup efektifnya, sehingga memperpanjang masa subur.
                </p>
                <hr />
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>Membuat Masa Subur Bekerja untuk Anda</b>{" "}
                  </u>{" "}
                </h2>
                Setelah mencapai pola hubungan intim yang teratur, Anda perlu mengenali beberapa hari sebelum ovulasi dan termasuk hari ovulasi itu sendiri. Mengidentifikasi "masa subur" ini akan secara signifikan meningkatkan peluang Anda untuk hamil. Konverter pembuahan yang disebutkan di atas dapat membantu Anda dalam proses pelacakan siklus biologis pribadi Anda, dan dengan demikian membantu Anda mengidentifikasi masa subur Anda. Untuk menggunakan konverter, catat hari pertama siklus Anda saat ini. Kemudian catat panjang siklus hingga siklus berikutnya.
                <hr />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa yang terjadi selama pembuahan?</h3>
              </div>
              <div className="info-section-body">
                Di dalam ovarium Anda setiap bulan, sekelompok sel telur mulai tumbuh dalam kantung kecil berisi cairan yang disebut folikel. Ovulasi terjadi ketika salah satu sel telur pecah dari folikel, biasanya terjadi sekitar dua minggu sebelum dimulainya periode menstruasi. Setelah sel telur keluar dari folikel, tubuh Anda melepaskan hormon yang membantu menebalkan lapisan rahim Anda sebagai persiapan untuk menerima sel telur. Sel telur bergerak melalui tuba falopi di mana pembuahan terjadi. Sel telur tetap di tuba falopi selama sekitar 24 jam menunggu pembuahan oleh satu sperma.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa itu pembuahan?</h3>
              </div>
              <div className="info-section-body">
                Setelah ovulasi, sel telur Anda tetap di tuba falopi selama 12 hingga 24 jam menunggu untuk dibuahi oleh salah satu dari 250 juta sperma (rata-rata) yang dikeluarkan pasangan Anda selama hubungan intim. Ketika pasangan Anda melepaskan sperma, sperma bergerak melalui vagina Anda dan ke dalam rahim Anda di mana sel telur yang telah dibuahi berada di tuba falopi. Hanya sekitar 400 sperma yang berhasil mencapai sel telur setelah perjalanan sekitar 10 jam, menurut rata-rata.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Kapan pembuahan terjadi?</h3>
              </div>
              <div className="info-section-body">
                Agar pembuahan terjadi, sperma harus mencapai sel telur dalam periode waktu tertentu. Sperma dapat bertahan hidup hingga 72 jam setelah ejakulasi, tetapi sel telur hanya dapat bertahan tidak lebih dari 24 jam setelah ovulasi. Jika sperma mencapai tuba falopi terlalu dini, mereka berisiko mati sebelum sel telur tiba. Dan jika sperma mencapai tuba falopi terlalu lambat, sel telur mungkin sudah berpindah. Selain itu, sel telur berada di salah satu tuba falopi hanya pada bulan tertentu.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa yang terjadi ketika sperma mencapai sel telur?</h3>
              </div>
              <div className="info-section-body">
                Sebelum pembuahan, ratusan sperma akan mengelilingi sel telur saat mereka mencoba mencapai inti sel telur. Hanya satu sperma yang berhasil menembus membran luar sel telur. Setelah sperma menembus sel telur, reaksi kimia langsung terjadi yang mencegah sperma lain menembusnya. Kromosom yang dibawa oleh sperma dan sel telur bergabung kemudian pembuahan secara resmi terjadi. Setelah sekitar satu minggu, bola sekitar 100 sel (disebut blastokista) mencapai rahim Anda dan ditanamkan di lapisan rahim.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Bagaimana saya bisa meningkatkan peluang kehamilan?</h3>
              </div>
              <div className="info-section-body">
                Ketika menyangkut pencapaian kehamilan, waktu adalah yang terpenting. Untuk meningkatkan peluang kehamilan, cobalah berhubungan seks kapan saja antara 72 jam sebelum ovulasi dan 24 jam setelah ovulasi.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Bagaimana saya bisa mempersiapkan kehamilan?</h3>
              </div>
              <div className="info-section-body">
                Hal terbaik yang dapat Anda lakukan untuk mempersiapkan kehamilan adalah membuat tubuh Anda dalam kondisi terbaik untuk memiliki anak. Anda harus berhenti mengonsumsi alkohol, merokok, dan mengonsumsi obat-obatan, bahkan yang dijual bebas. Anda harus memberi tahu dokter Anda tentang rencana kehamilan Anda dan meminta pendapatnya jika Anda perlu terus mengonsumsi obat resep. Setidaknya tiga bulan sebelum Anda berencana mencoba hamil, Anda harus mulai mengonsumsi multivitamin yang mengandung setidaknya 400 mikrogram asam folat untuk mengurangi risiko cacat lahir pada bayi Anda.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Akankah saya langsung tahu bahwa saya hamil?</h3>
              </div>
              <div className="info-section-body">
                Hormon kehamilan (HCG) ada dalam darah Anda setelah pembuahan. Namun, tes kehamilan tidak dapat mendeteksi HCG dalam urin Anda sampai setelah sel telur menempel di rahim selama implantasi. Paling cepat, tes kehamilan yang dijual bebas tidak akan menunjukkan positif sampai sembilan hingga sepuluh hari setelah ovulasi. Kebanyakan wanita tidak merasakan gejala kehamilan awal sampai setelah implantasi, tetapi beberapa mungkin melihat gejala lebih awal.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default ConceptionCalculator;